module.exports = __webpack_public_path__ + "static/media/waiting_avatar.36091848.svg";